import axios from 'axios';

const API_URL = 'http://dev.ouicsport.fr/api/home';

export const fetchAllSport = () => {
  return axios.get(`${API_URL}/all-sport`);
};

export const fetchAllTypes = () => {
  return axios.get(`${API_URL}/all-types`);
};
